import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FileUploadService } from 'src/app/services/file-upload/file-upload.service';

@Component({
  selector: 'app-choose-esignature',
  templateUrl: './choose-esignature.component.html',
  styleUrl: './choose-esignature.component.scss'
})
export class ChooseEsignatureComponent    implements OnChanges {

  @Input()
  signature: string = '';

  @Output()
  signatureChange =
    new EventEmitter<string>();


  @Input()
  defaultFullName: string = '';


  selectedOption:
    'typed' |
    'draw' |
    'upload' = 'typed';


  fullName: string = '';

  uploadedSignatureUrl: string = '';

  isUploading: boolean = false;

  uploadError: string = '';


  constructor(
    private uploadService: FileUploadService
  ) {}


  ngOnChanges(
    changes: SimpleChanges
  ): void {

    if (
      changes['defaultFullName'] &&
      this.defaultFullName &&
      !this.fullName
    ) {

      this.fullName =
        this.defaultFullName.trim();

    }

  }


  // ----------------------------------------------------------
  // CHANGE OPTION
  // ----------------------------------------------------------

  onOptionChange(): void {

    this.uploadError = '';

  }


  // ----------------------------------------------------------
  // TYPED SIGNATURE
  // ----------------------------------------------------------

  submitTypedSignature(): void {

    const value =
      this.fullName?.trim();

    if (!value) {
      return;
    }

    this.setSignature(
      value
    );

  }


  // ----------------------------------------------------------
  // DRAWN SIGNATURE
  // ----------------------------------------------------------

  handleSignaturePad(
    dataUrl: string
  ): void {

    if (!dataUrl) {
      return;
    }

    this.setSignature(
      dataUrl
    );

  }


  // ----------------------------------------------------------
  // UPLOAD SIGNATURE
  // ----------------------------------------------------------

  onFileUpload(
    event: Event
  ): void {

    const input =
      event.target as HTMLInputElement;

    const file =
      input.files?.[0];

    if (!file) {
      return;
    }


    this.uploadError = '';


    // Validate image
    if (
      !file.type.startsWith('image/')
    ) {

      this.uploadError =
        'Please select a valid image file.';

      input.value = '';

      return;

    }


    // Optional 5 MB limit
    const maxSize =
      5 * 1024 * 1024;

    if (
      file.size > maxSize
    ) {

      this.uploadError =
        'Signature image must be less than 5 MB.';

      input.value = '';

      return;

    }


    this.isUploading = true;


    this.uploadService
      .uploadSingleFile(
        file,
        'VOC-form'
      )
      .subscribe({

        next: (
          response: any
        ) => {

          this.isUploading =
            false;


          const uploadedUrl =
            response?.publicUrl || '';


          if (!uploadedUrl) {

            this.uploadError =
              'Unable to get uploaded signature URL.';

            return;

          }


          this.uploadedSignatureUrl =
            uploadedUrl;


          // Save URL into participant.signature
          this.setSignature(
            uploadedUrl
          );

        },


        error: (
          error: any
        ) => {

          console.error(
            'Signature upload failed:',
            error
          );


          this.isUploading =
            false;


          this.uploadError =
            'Unable to upload signature. Please try again.';

        }

      });

  }


  // ----------------------------------------------------------
  // SET SIGNATURE
  // ----------------------------------------------------------

  private setSignature(
    value: string
  ): void {

    this.signature =
      value;


    this.signatureChange.emit(
      value
    );

  }


  // ----------------------------------------------------------
  // REMOVE CURRENT SIGNATURE
  // ----------------------------------------------------------

  removeSignature(): void {

    this.signature = '';

    this.uploadedSignatureUrl = '';

    this.signatureChange.emit('');

  }


  // ----------------------------------------------------------
  // CHECK IF SIGNATURE IS IMAGE
  // ----------------------------------------------------------

  isImageSignature(
    value: string
  ): boolean {

    if (!value) {
      return false;
    }


    return (
      value.startsWith('data:image/') ||
      value.startsWith('http://') ||
      value.startsWith('https://')
    );

  }

}
 